<template>
  <panel-covid :schema="schema" />
</template>

<script>
import PanelCovid from '@/components/PanelCovid'
import rootSchema from '@/schema'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  name: 'Panel',
  components: {
    PanelCovid
  },
  computed: {
    schema() {
      return rootSchema.properties[this.$route.params.slug]
    }
  },
  beforeRouteEnter(to, _, next) {
    const slug = to.params.slug
    const schema = rootSchema.properties[slug]

    if (!slug || !schema) {
      Toast.open({
        message: 'El panel requerido no existe!',
        type: 'is-danger'
      })
      next('/')
    } else {
      next()
    }
  }
}
</script>
